const PREFIX = '/api';
const API_SUBSCRIPTION_ROUTE = `${PREFIX}/subscription`;
const API_SUBSCRIPTION_AGREEMENT_ROUTE = `${API_SUBSCRIPTION_ROUTE}/agreement`;
export const API_SUBSCRIPTION_AGREEMENT_ID_ROUTE = ({ subscriptionId }) => `${API_SUBSCRIPTION_AGREEMENT_ROUTE}/${subscriptionId}`;
const API_SUBSCRIPTION_SELL_ROUTE = `${API_SUBSCRIPTION_ROUTE}/sell`;
export const API_SUBSCRIPTION_SELL_ID_ROUTE = ({ subscriptionId }) => `${API_SUBSCRIPTION_SELL_ROUTE}/${subscriptionId}`;

const COMPANY_ROUTE = `${PREFIX}/company`;
export const COMPANY_PAY_PRO_STATUS_ROUTE = `${COMPANY_ROUTE}/pay-pro-status`;

const API_CLIENT_ROUTE = `${PREFIX}/client`;
const API_CLIENT_PASSWORD_ROUTE = `${API_CLIENT_ROUTE}/password`;
export const API_CLIENT_PASSWORD_REQUEST_RESET_CODE_ROUTE = `${API_CLIENT_PASSWORD_ROUTE}/request-reset-code`;
export const API_CLIENT_PASSWORD_VERIFY_RESET_CODE_ROUTE = `${API_CLIENT_PASSWORD_ROUTE}/verify-reset-code`;
export const API_CLIENT_PASSWORD_SET_NEW_ROUTE = `${API_CLIENT_PASSWORD_ROUTE}/set-new`;
